import React from 'react';
import { Calendar, MapPin, Users, Clock, PartyPopper } from 'lucide-react';

const SilentCzechHero = () => {
  return (
    <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/sc6i15yr_Sni%CC%81mek%20obrazovky%202026-03-11%20v%C2%A015.07.59.png')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-orange-900/85 via-orange-800/80 to-red-900/85"></div>
      </div>
      
      {/* Logos - Top */}
      <div className="absolute top-6 left-0 right-0 z-20 px-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          {/* Silent Czech Logo */}
          <div className="bg-orange-600/95 backdrop-blur-sm rounded-xl px-6 py-3 shadow-lg">
            <img 
              src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/w7woqo6y_silent%20czech%20logo.jpg" 
              alt="SILENT-CZECH"
              className="h-10 w-auto"
            />
          </div>
          
          {/* VšeProAkci Logo */}
          <div className="bg-orange-600/95 backdrop-blur-sm rounded-xl px-6 py-3 shadow-lg">
            <img 
              src="https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/4t7rchw6_VPA-logo-white.png" 
              alt="Vše pro akci"
              className="h-8 w-auto"
            />
          </div>
        </div>
      </div>
      
      <div className="relative z-10 text-center text-white px-4 max-w-5xl mx-auto mt-8">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-2 rounded-full mb-6 border border-white/20">
          <PartyPopper className="w-5 h-5 text-amber-300" />
          <span className="text-sm font-medium tracking-wide">Firemní výročí</span>
        </div>
        
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          30. výročí firmy SILENT-CZECH
        </h1>
        
        <p className="text-lg sm:text-xl mb-8 text-orange-100 max-w-2xl mx-auto">
          Kompletní realizace firemního open day pro zaměstnance, rodiny a obchodní partnery
        </p>
        
        <div className="flex flex-wrap justify-center gap-6 text-sm sm:text-base">
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20">
            <Calendar className="w-5 h-5 text-amber-300" />
            <span><strong className="font-semibold">Čtvrtek 24. 9. 2026</strong></span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20">
            <Clock className="w-5 h-5 text-amber-300" />
            <span>12:00–24:00</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20">
            <MapPin className="w-5 h-5 text-amber-300" />
            <span>Areál firmy, Valašské Meziříčí</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/20">
            <Users className="w-5 h-5 text-amber-300" />
            <span>cca 200 osob</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SilentCzechHero;
